import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { Button } from "../ui/button";
import SortableFieldList from "../settings/reporttemplates/SortableFieldList";
import { Loader2 } from "lucide-react";

const ColumnCustomizerDialog = ({ open, onOpenChange, columns, registry, defaults, onSave, saving }) => {
  const [items, setItems] = useState(columns || []);
  useEffect(() => { if (open) setItems(columns || []); }, [open, columns]);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="column-customizer-dialog">
        <DialogHeader>
          <DialogTitle>Customize Table Columns</DialogTitle>
        </DialogHeader>
        <p className="text-xs text-muted-foreground -mt-2">
          Drag to reorder, check to show/hide, and type a custom name to rename a column (visual only — leave blank for the default name). The layout is saved for the whole account.
        </p>
        <div className="max-h-[55vh] overflow-y-auto pr-1">
          <SortableFieldList items={items} registry={registry} onChange={setItems} renamable={true} testPrefix="fin-col" />
        </div>
        <DialogFooter className="flex-row justify-between sm:justify-between gap-2">
          <Button type="button" variant="ghost" size="sm" onClick={() => setItems(defaults)} data-testid="fin-col-reset-btn">
            Reset to default
          </Button>
          <div className="flex gap-2">
            <Button type="button" variant="outline" size="sm" onClick={() => onOpenChange(false)} data-testid="fin-col-cancel-btn">
              Cancel
            </Button>
            <Button type="button" size="sm" onClick={() => onSave(items)} disabled={saving} data-testid="fin-col-save-btn">
              {saving && <Loader2 className="w-3.5 h-3.5 mr-1.5 animate-spin" />} Save
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ColumnCustomizerDialog;
